"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.StyledIcon = void 0;

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _theme = require("../helpers/theme");

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _templateObject6() {
  var data = _taggedTemplateLiteral(["\n  ", ";\n"]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = _taggedTemplateLiteral(["\n  padding: 11px 16px;\n  cursor: pointer;\n  color: #ffffff;\n  outline: none;\n  border-radius: 2px;\n  font-family: 'Sofia Pro';\n  font-size: 12px;\n  font-weight: bold;\n  line-height: 16px;\n  ", ";\n  &:disabled {\n    border: 1px solid ", ";\n    color: ", ";\n    background-color: ", ";\n    cursor: no-drop;\n  }\n  ", ";\n  ", ";\n  ", ";\n"]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n    border: 1px solid ", ";\n    color: #000000;\n    background-color: ", ";\n\n    &:hover {\n      border: 1px solid ", ";\n      background-color: ", ";\n    }\n    &:active {\n      border: 1px solid ", ";\n      background-color: ", ";\n    }\n  "]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n    color: #000000;\n    border: 1px solid ", ";\n    background-color: ", ";\n\n    &:hover {\n      border: 1px solid ", ";\n      background-color: ", ";\n    }\n\n    &:active {\n      border: 1px solid ", ";\n      background-color: ", ";\n    }\n  "]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n        &:hover {\n          border: 1px solid ", ";\n          background-color: ", ";\n        }\n        &:active {\n          border: 1px solid ", ";\n          background-color: ", ";\n        }\n      "]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n    background-color: ", ";\n    box-sizing: border-box;\n    border: 1px solid ", ";\n\n    ", "\n  "]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var buttonStyles = {
  primary: (0, _styledComponents.css)(_templateObject(), _theme.colors.primary.background, _theme.colors.primary.background, function (props) {
    return !props.disabled && (0, _styledComponents.css)(_templateObject2(), _theme.colors.primary.hover, _theme.colors.primary.hover, _theme.colors.primary.active, _theme.colors.primary.active);
  }),
  secondary: (0, _styledComponents.css)(_templateObject3(), _theme.colors.secondary.border, _theme.colors.secondary.background, _theme.colors.secondary.hover.border, _theme.colors.secondary.hover.background, _theme.colors.secondary.active.background, _theme.colors.secondary.active.background),
  tertiary: (0, _styledComponents.css)(_templateObject4(), _theme.colors.tertiary.background, _theme.colors.tertiary.background, _theme.colors.tertiary.hover, _theme.colors.tertiary.hover, _theme.colors.tertiary.active, _theme.colors.tertiary.active)
};

var StyledButton = _styledComponents["default"].button(_templateObject5(), function (props) {
  return _theme.sizes[props.size];
}, _theme.colors.disabled.border, _theme.colors.disabled.color, _theme.colors.disabled.border, function (props) {
  return props.primary && buttonStyles['primary'];
}, function (props) {
  return props.secondary && buttonStyles['secondary'];
}, function (props) {
  return props.tertiary && buttonStyles['tertiary'];
});

var StyledIcon = _styledComponents["default"].span(_templateObject6(), function (props) {
  return props.text && _theme.iconPositions[props.iconPosition];
});

exports.StyledIcon = StyledIcon;
var _default = StyledButton;
exports["default"] = _default;